import axios from 'axios';

export declare interface JournalIssueCredit {
  AssessmentUrl?: string;
  ElectiveCredit?: number;
  EndDate?: string;
  HasAccess?: boolean;
  HasCredit?: boolean;
  PrescribedCredit?: number;
  SessionId?: number;
}

const requestCache: { [key: string]: Promise<JournalIssueCredit | null> } = {};

/**
 * For making requests to https://www.aafp.org/credit-reporting-api/assessment/journal/credit/<issueIdentifier>/<aafpId>
 */
export class CreditReportingService {
  private endpoint: string;

  constructor(endpoint: string) {
    this.endpoint = endpoint;
  }

  /**
   * Returns a JournalIssueCreditDto from the API
   *
   * @Param issueIdentifier - identifies the journal, volume, and issue
   * @Param aafpId - a user id, previously returned from https://www.aafp.org/jsparse/AAFPUser.js
   */
  public async get(issueIdentifier: string, aafpId?: string): Promise<JournalIssueCredit | null> {
    const cacheId = this.createCacheId(issueIdentifier, aafpId);

    if (cacheId in requestCache) {
      return requestCache[cacheId];
    } else {
      return this.fetch(issueIdentifier, aafpId);
    }
  }

  private async fetch(issueIdentifier: string, aafpId?: string): Promise<JournalIssueCredit | null> {
    const cacheId = this.createCacheId(issueIdentifier, aafpId);

    const request = axios
      .get<JournalIssueCredit>(cacheId)
      .then(({ data }) => {
        return data;
      })
      .catch(() => {
        return null;
      });

    requestCache[cacheId] = request;

    return request;
  }

  private createCacheId(issueIdentifier: string, aafpId?: string): string {
    return `${this.endpoint}/${issueIdentifier}${aafpId ? '/' + aafpId : ''}`;
  }
}
